import { useMutation } from '@tanstack/react-query'

import { dataOrThrow } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'

export function useDownloadPetHistory(petId: string) {
  const api = usePortalApi()
  return useMutation({
    mutationFn: async () => {
      const pdf = dataOrThrow(await api.get('/pets/:id/history', { params: { id: petId } }))
      const url = URL.createObjectURL(pdf)
      const link = document.createElement('a')
      link.href = url
      link.download = pdf.name
      link.click()
      setTimeout(() => URL.revokeObjectURL(url), 30_000)
    },
  })
}
